(() => {
  const initialURL = location.href;
  const initialTitle = document.title;
  let busy = false;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = () => innerWidth <= 750 || matchMedia('(pointer: coarse)').matches;
  const books = () => document.querySelector('[data-av-books]');
  const cover = () => document.querySelector('.av-cover');
  function closeMobileMenu() {
    const menu = document.querySelector('[data-av-books-mobile-menu]');
    const toggle = document.querySelector('[data-av-books-menu-toggle]');
    if (!menu || !toggle) return;
    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Abrir menú');
    const finish = () => { if (!menu.classList.contains('is-open')) menu.hidden = true; };
    if (reduced()) finish(); else setTimeout(finish, 430);
  }
  function showBook(handle) {
    const panel = books();
    if (!panel) return;
    handle ||= panel.dataset.initialBook;
    const slides = [...panel.querySelectorAll('[data-book]')];
    const index = Math.max(0, slides.findIndex(slide => slide.dataset.book === handle));
    slides.forEach((slide, i) => { slide.hidden = i !== index; });
    slides.forEach(slide => {
      slide.classList.remove('is-book-open');
      const toggle = slide.querySelector('[data-av-toggle-book]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.querySelector('[data-av-book-toggle-label]').textContent = 'abrir';
      }
      const spread = slide.querySelector('.av-book-spread');
      if (spread) spread.setAttribute('aria-hidden', 'true');
    });
    panel.querySelector('[data-book-count]').textContent = slides.length ? `${index + 1} / ${slides.length}` : '';
    panel.querySelectorAll('[data-book-step]').forEach(button => { button.disabled = slides.length < 2; });
    return slides[index];
  }
  // El índice se imprime con el contexto de la portada; al abrir libros sin recargar
  // hay que mover la marca de página actual a mano.
  function markIndex(open) {
    document.querySelectorAll('.av-page-index').forEach(index => {
      const links = [...index.querySelectorAll('a[href]')];
      const current = links.find(link => {
        const destination = new URL(link.href, location.href);
        return open ? destination.searchParams.get('view') === 'libros' : destination.pathname === '/' && !destination.search;
      });
      links.forEach(link => link.removeAttribute('aria-current'));
      current?.setAttribute('aria-current', 'page');
    });
  }
  async function switchView(open, animate = true) {
    if (busy || !cover() || !books()) return;
    busy = true;
    const home = cover(), panel = books();
    const from = open ? home.querySelector('.av-footer-seal') : panel.querySelector('.av-books-seal');
    const box = from.getBoundingClientRect();
    const style = getComputedStyle(from);
    const clone = document.createElement('span');
    clone.textContent = 'ALMAS VIEJAS EDITORIAL';
    clone.setAttribute('aria-hidden', 'true');
    Object.assign(clone.style, { position: 'fixed', left: `${box.left}px`, top: `${box.top}px`, width: `${box.width}px`, height: `${box.height}px`, color: style.color, fontFamily: style.fontFamily, fontSize: style.fontSize, fontWeight: style.fontWeight, lineHeight: style.lineHeight, letterSpacing: style.letterSpacing, whiteSpace: 'nowrap', zIndex: '9999', pointerEvents: 'none', transformOrigin: 'top left' });
    home.hidden = open;
    panel.hidden = !open;
    markIndex(open);
    scrollTo(0, 0);
    const destination = open ? panel.querySelector('.av-books-seal') : home.querySelector('.av-footer-seal');
    const target = destination.getBoundingClientRect();
    if (animate && !reduced()) {
      document.body.append(clone);
      destination.style.visibility = 'hidden';
      const content = open ? panel.querySelector('.av-books-stage') : home.querySelector('.av-footer-bottom');
      // El viaje del sello marca el ritmo de la transición: largo se percibía como
      // una espera, no como un gesto.
      content.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, delay: 90, fill: 'backwards' });
      try {
        await clone.animate([{ transform: 'none' }, { transform: `translate(${target.left - box.left}px, ${target.top - box.top}px) scale(${target.width / box.width})` }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' }).finished;
      } finally { clone.remove(); destination.style.visibility = ''; }
    }
    destination.focus({ preventScroll: true });
    busy = false;
  }
  document.addEventListener('click', event => {
    const menuToggle = event.target.closest?.('[data-av-books-menu-toggle]');
    if (menuToggle) {
      event.preventDefault();
      const menu = document.querySelector('[data-av-books-mobile-menu]');
      const opening = menu?.hidden;
      if (menu && opening) {
        menu.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
      } else if (menu) {
        menu.classList.remove('is-open');
        const finish = () => { if (!menu.classList.contains('is-open')) menu.hidden = true; };
        if (reduced()) finish(); else setTimeout(finish, 430);
      }
      menuToggle.setAttribute('aria-expanded', String(Boolean(opening)));
      menuToggle.setAttribute('aria-label', opening ? 'Cerrar menú' : 'Abrir menú');
      return;
    }
    if (!event.target.closest?.('[data-av-books-mobile-menu]')) closeMobileMenu();
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
    const target = event.target.closest?.('[data-av-open-books], [data-av-return], [data-book-step], [data-av-buy], [data-av-add-cart], [data-av-toggle-book]');
    if (!target) return;
    if (target.matches('[data-av-toggle-book]')) {
      event.preventDefault();
      const slide = target.closest('.av-book-slide');
      const spread = slide?.querySelector('.av-book-spread');
      const opening = !slide?.classList.contains('is-book-open');
      slide?.classList.toggle('is-book-open', opening);
      target.setAttribute('aria-expanded', String(opening));
      target.querySelector('[data-av-book-toggle-label]').textContent = opening ? 'cerrar' : 'abrir';
      if (spread) spread.setAttribute('aria-hidden', String(!opening));
    } else if (target.matches('[data-av-buy], [data-av-add-cart]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (target.disabled) return;
      const buyNow = target.matches('[data-av-buy]');
      const detail = target.closest('.av-book-detail');
      const variant = detail?.querySelector('[data-book-variant]:checked')?.value || target.dataset.variantId;
      const error = detail?.querySelector('[data-buy-error]');
      const originalLabel = target.textContent;
      target.disabled = true;
      target.setAttribute('aria-busy', 'true');
      target.textContent = 'procesando…';
      if (error) error.hidden = true;
      fetch(books().dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
      }).then(response => {
        if (!response.ok) throw new Error('No se pudo añadir el libro.');
        if (buyNow) {
          location.assign('/checkout');
          return null;
        }
        return fetch(books().dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
      }).then(response => {
        if (!response) return null;
        if (!response.ok) throw new Error('No se pudo actualizar el carrito.');
        return response.json();
      }).then(cart => {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
        target.removeAttribute('aria-busy');
        target.textContent = 'agregado';
        setTimeout(() => {
          target.disabled = false;
          target.textContent = originalLabel;
        }, 1200);
      }).catch(() => {
        target.disabled = false;
        target.removeAttribute('aria-busy');
        target.textContent = originalLabel;
        if (error) {
          error.textContent = 'No pudimos iniciar la compra. Inténtalo de nuevo.';
          error.hidden = false;
        }
      });
    } else if (target.matches('[data-av-open-books]') && cover() && books()) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy) return;
      const slide = showBook(new URL(location.href).searchParams.get('libro'));
      const url = new URL(target.href);
      if (slide) url.searchParams.set('libro', slide.dataset.book);
      history.pushState({}, '', url);
      document.title = 'Libros · Almas Viejas Editorial';
      void switchView(true, !mobile());
    } else if (target.matches('[data-av-return]') && cover()) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy) return;
      history.pushState({}, '', initialURL);
      document.title = initialTitle;
      void switchView(false, !mobile());
    } else if (target.matches('[data-book-step]')) {
      const slides = [...books().querySelectorAll('[data-book]')];
      if (!slides.length || busy) return;
      const index = slides.findIndex(slide => !slide.hidden);
      const next = slides[(index + Number(target.dataset.bookStep) + slides.length) % slides.length];
      showBook(next.dataset.book);
      if (!reduced()) next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 250 });
      const url = new URL(location.href);
      url.searchParams.set('libro', next.dataset.book);
      history.replaceState({}, '', url);
    }
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches?.('[data-book-variant]')) return;
    const detail = event.target.closest('.av-book-detail');
    const price = detail?.querySelector('[data-book-price]');
    if (price) price.textContent = event.target.dataset.price;
  });
  addEventListener('popstate', () => {
    showBook(new URL(location.href).searchParams.get('libro'));
    if (cover()) {
      const open = new URL(location.href).searchParams.get('view') === 'libros';
      document.title = open ? 'Libros · Almas Viejas Editorial' : initialTitle;
      void switchView(open, false);
    }
  });
  showBook(new URL(location.href).searchParams.get('libro'));
})();
